<template>
	<div class="reviewed">
		<vs-table ref="table"    :max-items="10"  :data="culturelist">
		  <template slot="thead">
		    <vs-th >ID</vs-th>
		    <vs-th >姓名</vs-th>
			<vs-th >性别</vs-th>
		    <vs-th >手机号</vs-th>
			<vs-th >邮箱</vs-th>
			<vs-th >注册时间</vs-th>
			<vs-th >状态</vs-th>
			<vs-th >操作</vs-th>
		  </template>
		    <template slot-scope="{data}">
		      <tbody>
		        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
		          <vs-td>
		            <p class="product-name font-medium">{{ tr.id }}</p>
		          </vs-td>
		          <vs-td>
		            <p class="product-category">{{ tr.name }}</p>
		          </vs-td>
				  <vs-td>
				    <p class="product-price">{{ tr.sex==0?'未知':tr.sex==1?'男':'女' }}</p>
				  </vs-td>
		          <vs-td>
		            <p class="product-price">{{ tr.phone }}</p>
		          </vs-td>
				  <vs-td>
				    <p class="product-price">{{ tr.email }}</p>
				  </vs-td>
				  <vs-td>
				    <p class="product-price">{{ tr.createTime?tr.createTime:'------' }}</p>
				  </vs-td>
				  <vs-td>
				    <p class="product-price text-danger">待审核</p>
				  </vs-td>
				  <vs-td>
				    <vs-button class="mr-4" color="primary" type="filled" @click="acceptAlert(tr.id,10)"  size="small">通过</vs-button>
					<vs-button class="mr-4" color="danger" type="filled" @click="acceptAlert(tr.id,2)"  size="small">驳回</vs-button>
				  </vs-td>
		        </vs-tr>
		      </tbody>
		    </template>
		</vs-table>
		<vs-pagination class="mt-4" :total="total" v-model="itemsPerPage" ></vs-pagination>
	</div>
</template>
<script>
	export default {
	    data() {
	        return {
				culturelist: [],
				total:0,
				itemsPerPage:1,
			}
	    },
		mounted() {
			this.getlist();
		},
		watch: {
		    itemsPerPage:'getlist'
		}, 
		methods:{
			getlist(){    //获取列表
					 const thisIns = this;
					 this.$api.memberlist({pageNum:thisIns.itemsPerPage,pageSize:10,status:1}).then(function (response) {
					 	console.log("列表数据：",response);
					 	if(response.code==0){
					 		 thisIns.culturelist=response.data.data;
					 		 thisIns.total=response.data.pages;
					 	}else{
					 		thisIns.$vs.notify({
					 			  title:"提示",
					 			  color:'warning',
					 			  text:response.message,
					 			  position:'top-center'
					 		});
					 	}
					   }) 
			},
			acceptAlert(id,status){
				const that = this;
				this.$api.userExamine({userId:id,status:status}).then(function (response) {
					console.log("提交结果：",response);
					if(response.code==0){
						 that.$vs.notify({
						 	  title:"提示",
						 	  color:'success',
						 	  text:response.message,
						 	  position:'top-center'
						 });
						 that.getlist();
					}else{
						that.$vs.notify({
							  title:"提示",
							  color:'warning',
							  text:response.message,
							  position:'top-center'
						});
					}
				  }) 
			},
		},
	}
</script>
<style type="text/css">
	
</style>
